import type { ScreenItem } from 'shared/src/types';
import { HomeScreen } from './screens/Home/Home.screen';
import { CategoryScreen } from './screens/Category';
import { TodayShippingScreen } from './screens/TodayShipping';
import { ContentsScreen } from './screens/Contents';
// import { LikeScreen } from './screens/Like';
import { MyPageScreen } from './screens/MyPage';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type HomeStackParamList = {};

export const HomeScreens: ScreenItem[] = [
  // {
  //   name: 'Home',
  //   component: HomeScreen,
  //   path: '/',
  //   options: {
  //     tabBarLabel: '홈',
  //   },
  // },
  // {
  //   name: 'Category',
  //   component: CategoryScreen,
  //   path: '/category',
  //   options: {
  //     tabBarLabel: '카테고리',
  //   },
  // },
];
export const HomeTabScreens: ScreenItem[] = [
  {
    name: 'Home',
    component: HomeScreen,
    path: '/',
    options: {
      tabBarLabel: '홈',
    },
  },
  {
    name: 'Category',
    component: CategoryScreen,
    path: '/overview',
    options: {
      tabBarLabel: '카테고리',
    },
  },
  {
    name: 'TodayShipping',
    component: TodayShippingScreen,
    path: '/today-shipping',
    options: {
      tabBarLabel: '오늘출발',
    },
  },
  {
    name: 'Contents',
    component: ContentsScreen,
    path: '/contents',
    options: {
      tabBarLabel: '콘텐츠',
    },
  },
  // TODO 화면 구성 후 배포
  // {
  //   name: 'Like',
  //   component: LikeScreen,
  //   path: '/like',
  //   options: {
  //     tabBarLabel: '찜',
  //   },
  // },
  {
    name: 'MyPage',
    component: MyPageScreen,
    path: '/mypage',
    options: {
      tabBarLabel: '마이페이지',
    },
  },
];
